import React from "react";
import "../styles/Guidelines.css";
import { FaFilePdf } from "react-icons/fa";
import { Worker, Viewer } from "@react-pdf-viewer/core";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";

// PDF file
import Guidelines_For_Parents from "../Assets/Pdfs/Guidelines_for_Parents.pdf";

export default function Guidelines() {
    const defaultLayoutPluginInstance = defaultLayoutPlugin();

    return (
        <div className="guidelines-page">
            <section className="guidelines-section pdf-section">
                <h2>
                    <FaFilePdf className="pdf-icon" /> Guidelines for Parents
                </h2>

                {/* PDF Viewer */}
                <div className="pdf-viewer">
                    <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
                        <Viewer
                            fileUrl={Guidelines_For_Parents}
                            plugins={[defaultLayoutPluginInstance]}
                        />
                    </Worker>
                </div>

                {/* Download Link */}
                <p className="pdf-download">
                    <a
                        href={Guidelines_For_Parents}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Download Guidelines for Parents
                    </a>
                </p>
            </section>

            <footer className="guidelines-footer">
                <p>Together, we ensure the best learning environment for students.</p>
            </footer>
        </div>
    );
}
